import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import { FaPowerOff, FaSyncAlt, FaExclamationTriangle, FaShieldAlt, FaCheckCircle } from 'react-icons/fa';

const SiteSettings = () => {
  const [settings,   setSettings]   = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [error,      setError]      = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const fetchSiteSettings = () => {
    setLoading(true);
    axiosInstance.get('/siteSettings')
      .then(r => setSettings(r.data))
      .catch(e => setError(e))
      .finally(() => setLoading(false));
  };
  useEffect(() => { fetchSiteSettings(); }, []);

  const toggle = () => {
    if (!settings) return;
    const next = !settings.bonusRequestsEnabled;
    setIsUpdating(true);
    axiosInstance.post('/siteSettings/update', { status: next })
      .then(() => setSettings(p => ({ ...p, bonusRequestsEnabled: next })))
      .catch(console.error)
      .finally(() => setIsUpdating(false));
  };

  const isActive = settings?.bonusRequestsEnabled;

  return (
    <div style={{ minHeight:'100vh', background:'#090a0c', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:"'Outfit','Inter',sans-serif", padding:28, boxSizing:'border-box' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap');
        @keyframes pulseDot{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.4;transform:scale(.7)}}
        @keyframes fadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}
        .ss-primary:hover:not(:disabled){filter:brightness(1.1);transform:translateY(-1px)}
        .ss-secondary:hover:not(:disabled){background:rgba(255,255,255,.08)!important;color:#fff!important}
      `}</style>

      {loading ? (
        <div style={{ color:'rgba(255,255,255,.25)', fontSize:'.85rem' }}>Yükleniyor...</div>
      ) : error ? (
        <div style={{ color:'#ef4444', fontSize:'.85rem' }}>Hata: {error.message}</div>
      ) : (
        <div style={{ width:'100%', maxWidth:440, animation:'fadeUp .35s ease both' }}>
          <div style={{
            background:'#111318',
            border:`1px solid ${isActive?'rgba(16,185,129,.2)':'rgba(239,68,68,.15)'}`,
            borderRadius:24, overflow:'hidden',
            boxShadow: isActive?'0 0 60px rgba(16,185,129,.06)':'0 0 60px rgba(239,68,68,.05)',
            transition:'border-color .4s, box-shadow .4s',
          }}>
            {/* Top glow çizgisi */}
            <div style={{ height:3, background: isActive?'linear-gradient(90deg,transparent,#10b981,transparent)':'linear-gradient(90deg,transparent,#ef4444,transparent)', transition:'background .4s' }} />

            <div style={{ padding:'36px 36px 32px' }}>
              {/* İkon */}
              <div style={{
                width:58, height:58, borderRadius:17, margin:'0 auto 22px',
                background: isActive?'rgba(16,185,129,.1)':'rgba(239,68,68,.09)',
                border:`1px solid ${isActive?'rgba(16,185,129,.22)':'rgba(239,68,68,.18)'}`,
                display:'flex', alignItems:'center', justifyContent:'center',
                color: isActive?'#10b981':'#ef4444', fontSize:'1.35rem',
                boxShadow:`0 0 28px ${isActive?'rgba(16,185,129,.13)':'rgba(239,68,68,.1)'}`,
                transition:'all .4s',
              }}>
                <FaShieldAlt />
              </div>

              {/* Başlık */}
              <div style={{ textAlign:'center', marginBottom:26 }}>
                <h2 style={{ margin:'0 0 8px', fontSize:'1.2rem', fontWeight:700, color:'#f8fafc', letterSpacing:'-.3px' }}>Sistem Kontrolü</h2>
                <p style={{ margin:0, fontSize:'.77rem', color:'rgba(255,255,255,.28)', lineHeight:1.65 }}>Bonus talep sisteminin genel açık/kapalı durumunu yönetiyorsunuz.</p>
              </div>

              {/* Bilgi banner */}
              <div style={{
                display:'flex', alignItems:'center', gap:10, padding:'12px 16px',
                borderRadius:12, marginBottom:22,
                background: isActive?'rgba(16,185,129,.07)':'rgba(239,68,68,.07)',
                border:`1px solid ${isActive?'rgba(16,185,129,.14)':'rgba(239,68,68,.14)'}`,
                color: isActive?'#6ee7b7':'#fca5a5', fontSize:'.77rem', fontWeight:500,
                transition:'all .4s',
              }}>
                {isActive
                  ? <><FaCheckCircle style={{ color:'#10b981', flexShrink:0 }} />Sistem çalışıyor. Kullanıcılar bonus talebinde bulunabilir.</>
                  : <><FaExclamationTriangle style={{ color:'#ef4444', flexShrink:0 }} />Sistem kapalı. Kullanıcı talepleri durduruldu.</>
                }
              </div>

              {/* Durum badge */}
              <div style={{
                display:'flex', alignItems:'center', justifyContent:'center', gap:10,
                padding:'14px', borderRadius:13, marginBottom:24,
                background: isActive?'rgba(16,185,129,.06)':'rgba(239,68,68,.06)',
                border:`1px solid ${isActive?'rgba(16,185,129,.13)':'rgba(239,68,68,.13)'}`,
                transition:'all .4s',
              }}>
                <span style={{ width:10, height:10, borderRadius:'50%', flexShrink:0, background: isActive?'#10b981':'#ef4444', boxShadow:`0 0 10px ${isActive?'#10b981':'#ef4444'}`, animation:'pulseDot 2s infinite' }} />
                <span style={{ fontSize:'.8rem', fontWeight:800, letterSpacing:'1.6px', textTransform:'uppercase', color: isActive?'#10b981':'#ef4444', transition:'color .4s' }}>
                  {isActive ? 'Sistem Aktif' : 'Sistem Kapalı'}
                </span>
              </div>

              {/* Butonlar */}
              <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
                <button className="ss-primary" onClick={toggle} disabled={isUpdating} style={{
                  width:'100%', padding:'13px', borderRadius:12, border:'none',
                  cursor:isUpdating?'not-allowed':'pointer',
                  background: isActive?'linear-gradient(135deg,#ef4444,#dc2626)':'linear-gradient(135deg,#10b981,#059669)',
                  color:'#fff', fontSize:'.87rem', fontWeight:700,
                  display:'flex', alignItems:'center', justifyContent:'center', gap:9,
                  boxShadow: isActive?'0 6px 20px rgba(239,68,68,.28)':'0 6px 20px rgba(16,185,129,.28)',
                  fontFamily:'inherit', transition:'all .2s', opacity:isUpdating?.7:1,
                }}>
                  <FaPowerOff />
                  {isUpdating ? 'Güncelleniyor...' : isActive ? 'Sistemi Kapat' : 'Sistemi Başlat'}
                </button>
                <button className="ss-secondary" onClick={fetchSiteSettings} disabled={isUpdating} style={{
                  width:'100%', padding:'11px', borderRadius:12,
                  border:'1px solid rgba(255,255,255,.07)', background:'rgba(255,255,255,.04)',
                  color:'rgba(255,255,255,.38)', fontSize:'.82rem', fontWeight:600, cursor:'pointer',
                  display:'flex', alignItems:'center', justifyContent:'center', gap:8,
                  fontFamily:'inherit', transition:'all .2s',
                }}>
                  <FaSyncAlt /> Verileri Yenile
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default SiteSettings;
